export default "__VITE_ASSET__4658442c__"